<div class="flex gap-4">
	@if (intakeActionsViewModel_()?.intakeCTA; as intakeCTA) {
		<ui-button
			preset="EXTRA_LOW_EMPHASIS"
			[label]="intakeCTA.label"
			[icon]="intakeCTA.leftIcon"
			[rightIcon]="intakeCTA.rightIcon"
			(click)="sendOrViewIntake()"
			[testHook]="testHooks.IntakeButton"
		/>
	}

	@if (!hideKebabMenu_()) {
		<ui-dropdown [items]="kebabItems_()">
			<ui-button
				dropdown-trigger
				preset="EXTRA_LOW_EMPHASIS"
				icon="dots-vertical"
				[testHook]="testHooks.IntakeDropdownButton"
			/>
		</ui-dropdown>
	}
</div>
